export const CloudMoon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27 24"
        className={`fill-current ${props.customClasses}`}
    >
        <title>Night</title>
        <path
            id="cloud-moon-icon"
            d="M16.068,16.533a2.993,2.993,0,0,0-4.645-3.694A4.485,4.485,0,0,0,3,15c0,.094.023.178.028.267A4.489,4.489,0,0,0,4.5,24H15.749a3.74,3.74,0,0,0,.319-7.467ZM26.5,13.988A7.05,7.05,0,0,1,21.7.933.423.423,0,0,0,21.566.15,9.3,9.3,0,0,0,19.921,0a9,9,0,0,0-8.995,9,8.785,8.785,0,0,0,.084,1.172,5.877,5.877,0,0,1,.783.666A4.5,4.5,0,0,1,17.971,15.5a5.17,5.17,0,0,1,2.508,2.466,8.983,8.983,0,0,0,6.426-3.3A.422.422,0,0,0,26.5,13.988Z"
        />
    </svg>
);

export const CloudSun = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 24"
        className={`fill-current ${props.customClasses}`}
    >
        <title>Morning</title>
        <path
            id="cloud-sun-icon"
            d="M26.962,15.264A2.526,2.526,0,0,0,27,15a2.991,2.991,0,0,0-4.6-2.531,5.244,5.244,0,0,0-10.027,2.156c0,.141.033.272.042.408A4.488,4.488,0,0,0,12.75,24H25.5a4.488,4.488,0,0,0,1.463-8.736ZM6.787,14.205a5.248,5.248,0,1,1,8.47-5.886A6.727,6.727,0,0,1,16.7,7.967l1.4-4.166a.711.711,0,0,0-.9-.9L13.078,4.274,11.133.394a.709.709,0,0,0-1.27,0L7.922,4.274,3.8,2.9a.714.714,0,0,0-.9.9L4.275,7.916.394,9.861a.709.709,0,0,0,0,1.27l3.881,1.94L2.9,17.186a.711.711,0,0,0,.9.9L7.369,16.9a6.057,6.057,0,0,1,1.106-1.57,5.169,5.169,0,0,1-1.687-1.125Zm-.225-3.712A3.937,3.937,0,0,0,9.745,14.35a6.014,6.014,0,0,1,1.181-.548,6.755,6.755,0,0,1,3.159-4.921,3.935,3.935,0,0,0-7.523,1.612Z"
        />
    </svg>
);

export const Sun = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className={`fill-current ${props.customClasses}`}
    >
        <title>Evening</title>
        <path
            id="sun-icon"
            d="M12,7.5A4.5,4.5,0,1,0,16.5,12,4.507,4.507,0,0,0,12,7.5Zm11.55,3.773L19.111,9.056l1.57-4.706a.81.81,0,0,0-1.027-1.027l-4.706,1.57L12.727.45a.812.812,0,0,0-1.453,0L9.056,4.889,4.345,3.319A.81.81,0,0,0,3.319,4.345l1.57,4.706L.45,11.273a.812.812,0,0,0,0,1.453l4.439,2.217-1.57,4.711a.81.81,0,0,0,1.027,1.027l4.706-1.57,2.217,4.439a.812.812,0,0,0,1.453,0l2.217-4.439,4.706,1.57a.81.81,0,0,0,1.027-1.027L19.1,14.948l4.439-2.217a.813.813,0,0,0,.009-1.458Zm-7.308,4.969a6,6,0,1,1,0-8.484A6.006,6.006,0,0,1,16.242,16.242Z"
        />
    </svg>
);

export const GitHub = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 35 35"
        className={`fill-current ${props.customClasses}`}
    >
        <title>GitHub</title>
        <path
            id="github-icon"
            d="M31,35H4a4,4,0,0,1-4-4V4A4.005,4.005,0,0,1,4,0H31a4,4,0,0,1,4,4V31A4,4,0,0,1,31,35ZM22.436,12.908a.705.705,0,0,1,.2.021,3.34,3.34,0,0,1,.089,2.394,3.537,3.537,0,0,1,.906,2.428c0,3.55-2.153,4.25-4.028,4.464a2.22,2.22,0,0,1,.6,1.675c0,.81,0,1.514-.008,1.98v.009c0,.227,0,.4,0,.494a.423.423,0,0,0,.448.451.824.824,0,0,0,.158-.017A9.081,9.081,0,0,0,18,9.176a9.08,9.08,0,0,0-2.788,17.631.818.818,0,0,0,.15.015.424.424,0,0,0,.452-.45c0-.093,0-.251,0-.461,0-.28-.006-.649-.008-1.078a4.123,4.123,0,0,1-.888.105,2.067,2.067,0,0,1-2.084-1.318,2.4,2.4,0,0,0-.979-1.324c-.254-.178-.367-.316-.337-.412.042-.134.357-.138.393-.138a1.873,1.873,0,0,1,1.356.932,1.734,1.734,0,0,0,1.558.989,2.466,2.466,0,0,0,1.01-.237,1.976,1.976,0,0,1,.56-1.21C14.518,22,12.37,21.3,12.37,17.751a3.54,3.54,0,0,1,.908-2.428,3.333,3.333,0,0,1,.086-2.394.759.759,0,0,1,.2-.021,4.2,4.2,0,0,1,2.23.948,8.341,8.341,0,0,1,2.209-.3,8.243,8.243,0,0,1,2.209.3A4.192,4.192,0,0,1,22.436,12.908Z"
        />
    </svg>
);

export const LinkedIn = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 35 35"
        className={`fill-current ${props.customClasses}`}
    >
        <title>LinkedIn</title>
        <path
            id="linkedin-icon"
            d="M31,35H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H31a4,4,0,0,1,4,4V31A4,4,0,0,1,31,35ZM19.815,17.726a1.933,1.933,0,0,1,1.918,1.66V25.15h3.415v-6.19a3.841,3.841,0,0,0-3.82-3.853,3.941,3.941,0,0,0-3.01,1.5V14.9H14.9V25.15h3.416V19.386A1.55,1.55,0,0,1,19.815,17.726ZM9.78,14.9V25.15h3.415V14.9ZM11.488,9.78a1.708,1.708,0,1,0,1.707,1.708A1.71,1.71,0,0,0,11.488,9.78Z"
        />
    </svg>
);

export const Medium = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 35 35"
        className={`fill-current ${props.customClasses}`}
    >
        <title>Medium</title>
        <path
            id="medium-icon"
            d="M31,35H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0H31a4.005,4.005,0,0,1,4,4V31A4,4,0,0,1,31,35ZM21.258,14.76h0v8.5c0,.23,0,.271-.146.419l-1.485,1.467v.314H26.84v-.314l-1.434-1.432a.441.441,0,0,1-.163-.419V12.774a.439.439,0,0,1,.163-.419l1.468-1.432v-.314H21.793L18.169,19.8l-4.12-9.194H8.718v.314l1.717,2.1a.733.733,0,0,1,.231.611v8.268a.966.966,0,0,1-.248.821L8.486,25.111v.314h5.477v-.314l-1.931-2.384a1,1,0,0,1-.266-.821V14.755l4.807,10.669h.558Z"
        />
    </svg>
);

export const YouTube = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 35 35"
        className={`fill-current ${props.customClasses}`}
    >
        <title>YouTube</title>
        <path
            id="youtube-icon"
            d="M31,35H4a4,4,0,0,1-4-4V4A4.005,4.005,0,0,1,4,0H31a4,4,0,0,1,4,4V31A4,4,0,0,1,31,35ZM17.5,10.5l-1.564.047c-1.063,0-2.247.031-3.52.094a14.546,14.546,0,0,0-2.6.283,2.325,2.325,0,0,0-1.7,1.738A20.553,20.553,0,0,0,7.7,17.5l.046.845c0,.593.031,1.3.092,2.091a11.314,11.314,0,0,0,.276,1.9,2.328,2.328,0,0,0,1.7,1.739A40.154,40.154,0,0,0,17.5,24.5l1.564-.047c1.062,0,2.246-.031,3.52-.094a14.566,14.566,0,0,0,2.6-.282,2.326,2.326,0,0,0,1.7-1.739A20.531,20.531,0,0,0,27.3,17.5l-.047-.846c0-.592-.031-1.3-.092-2.091a11.243,11.243,0,0,0-.276-1.9,2.323,2.323,0,0,0-1.7-1.738A40.047,40.047,0,0,0,17.5,10.5ZM15.522,20.507V14.494L20.629,17.5l-5.105,3.005Z"
        />
    </svg>
);

export const GitHubCircle = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        className={`fill-current ${props.customClasses}`}
    >
        <title>GitHub</title>
        <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
    </svg>
);

export const Location = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        className={`fill-current ${props.customClasses}`}
    >
        <title>Location</title>
        <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
    </svg>
);

export const ArrowRight = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        className={`fill-current stroke-current ${props.customClasses}`}
    >
        <path
            strokeWidth="0.5"
            fillRule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
        />
    </svg>
);

export const Bulb = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        className={`fill-current ${props.customClasses}`}
    >
        <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z" />
    </svg>
);
